// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #3a6b9e;
  --blue-mid: #4d82ba;
  --blue-soft: #7aaed4;
  --blue-pale: #e8f2fa;
  --blue-faint: #f2f7fc;
  --sand: #f5efe4;
  --ivory: #fdfaf6;
  --gold: #c4882a;
  --gold-soft: #dba84e;
  --ink: #1a2a3a;
  --muted: #5a7490;
  --border: rgba(58, 107, 158, 0.12);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'DM Sans', sans-serif;
  background: var(--ivory);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

button {
  transition: transform 0.12s ease, filter 0.12s ease, box-shadow 0.12s ease,
    opacity 0.12s ease, background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

button:active:not(:disabled) {
  transform: scale(0.96);
}

button:hover:not(:disabled) {
  filter: brightness(1.05);
}

/* Toggle-like controls (chips, role cards, pledge box) are plain divs with
   onClick, not <button>s — opt them in with this class for the same feel.
   Their selected/unselected state is just a background/border/color swap in
   React, so transition those too, not just the press transform. */
.tap-target {
  transition: transform 0.12s ease, filter 0.12s ease,
    background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.tap-target * {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.tap-target:active {
  transform: scale(0.97);
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;8FAC4F;AAC9F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;kEAGkE;AAClE;EACE;uEACqE;AACvE;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[":root {\n  --blue: #3a6b9e;\n  --blue-mid: #4d82ba;\n  --blue-soft: #7aaed4;\n  --blue-pale: #e8f2fa;\n  --blue-faint: #f2f7fc;\n  --sand: #f5efe4;\n  --ivory: #fdfaf6;\n  --gold: #c4882a;\n  --gold-soft: #dba84e;\n  --ink: #1a2a3a;\n  --muted: #5a7490;\n  --border: rgba(58, 107, 158, 0.12);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'DM Sans', sans-serif;\n  background: var(--ivory);\n  color: var(--ink);\n  -webkit-font-smoothing: antialiased;\n}\n\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\nbutton {\n  transition: transform 0.12s ease, filter 0.12s ease, box-shadow 0.12s ease,\n    opacity 0.12s ease, background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n\nbutton:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\nbutton:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n/* Toggle-like controls (chips, role cards, pledge box) are plain divs with\n   onClick, not <button>s — opt them in with this class for the same feel.\n   Their selected/unselected state is just a background/border/color swap in\n   React, so transition those too, not just the press transform. */\n.tap-target {\n  transition: transform 0.12s ease, filter 0.12s ease,\n    background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.tap-target * {\n  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.tap-target:active {\n  transform: scale(0.97);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
